/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RunColorDTO
 */
export interface RunColorDTO {
    /**
     * Color in #rrggbb format
     * @type {string}
     * @memberof RunColorDTO
     */
    color: string;
    /**
     * sys/name for EXPERIMENT, sys/custom_run_id for RUN
     * @type {string}
     * @memberof RunColorDTO
     */
    entityKey: string;
    /**
     * 
     * @type {string}
     * @memberof RunColorDTO
     */
    entityType: RunColorDTOEntityTypeEnum;
}


/**
 * @export
 */
export const RunColorDTOEntityTypeEnum = {
    Experiment: 'EXPERIMENT',
    Run: 'RUN'
} as const;
export type RunColorDTOEntityTypeEnum = typeof RunColorDTOEntityTypeEnum[keyof typeof RunColorDTOEntityTypeEnum];


/**
 * Check if a given object implements the RunColorDTO interface.
 */
export function instanceOfRunColorDTO(value: object): value is RunColorDTO {
    if (!('color' in value) || value['color'] === undefined) return false;
    if (!('entityKey' in value) || value['entityKey'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    return true;
}

export function RunColorDTOFromJSON(json: any): RunColorDTO {
    return RunColorDTOFromJSONTyped(json, false);
}

export function RunColorDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunColorDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'color': json['color'],
        'entityKey': json['entityKey'],
        'entityType': json['entityType'],
    };
}

export function RunColorDTOToJSON(value?: RunColorDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'color': value['color'],
        'entityKey': value['entityKey'],
        'entityType': value['entityType'],
    };
}

